export default __webpack_public_path__ + "static/kona-23119d96b7496552b4a198b58a607618.png";